var __TEMP__ = require('./flatten.js');var flatten = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_overRest.js');var overRest = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_setToString.js');var setToString = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = flatRest;
